// extracted by mini-css-extract-plugin
export default {"header":"header_header__pI66H","anchor":"header_anchor__55gV0"};